import { useState } from "react";
import { Menu } from "lucide-react";
import { CategoryPicker } from "@/components/CategoryPicker";
import { RecommendationPanel } from "@/components/RecommendationPanel";

export const NewInquiry = ({ catalog, onStart, onOpenSidebar }) => {
  const [categoryId, setCategoryId] = useState(null);
  const category = catalog?.categories.find((c) => c.id === categoryId);

  return (
    <div className="flex-1 overflow-y-auto relative" data-testid="new-inquiry-view">
      <div className="absolute inset-x-0 top-0 h-[480px] grid-bg pointer-events-none" />
      <div className="absolute -top-32 right-1/4 w-[500px] h-[500px] rounded-full bg-indigo-600/10 blur-[140px] pointer-events-none" />

      <header className="sticky top-0 z-10 h-16 flex items-center px-4 lg:px-10 bg-[#090A0F]/70 backdrop-blur-xl border-b border-slate-800/60">
        <button onClick={onOpenSidebar} className="lg:hidden mr-3 text-slate-400 hover:text-white" data-testid="open-sidebar-btn"><Menu className="w-5 h-5" /></button>
        <p className="text-xs font-semibold uppercase tracking-widest text-indigo-400">New inquiry</p>
      </header>

      <div className="relative max-w-5xl mx-auto px-4 lg:px-10 py-10 lg:py-14">
        <div className="rise">
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-100">
            What kind of inquiry<br className="hidden sm:block" /> do you have today?
          </h1>
          <p className="mt-4 text-sm sm:text-base text-slate-400 max-w-xl leading-relaxed">
            Choose a category and we'll rank the providers and models best suited for it. You can pick any model you like — there are no restrictions.
          </p>
        </div>

        <div className="mt-10">
          <CategoryPicker categories={catalog?.categories || []} selected={categoryId} onSelect={setCategoryId} />
        </div>

        {category && (
          <div className="mt-10" id="recommendation-panel">
            <RecommendationPanel key={category.id} catalog={catalog} category={category} onStart={onStart} />
          </div>
        )}
      </div>
    </div>
  );
};
